<template >
  <section class="paragraphs">
    <p class="font paragraphs__paragraph">{{paragraph}}</p>
  </section>
</template>

<script >
import BigTitle from "@/components/twelve-by-one-specific-components/BigTitle";
export default {
  name: "paragraphs",
  props: ["paragraph"],
  mounted() {},
  data() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>

<style scoped lang="scss">
.paragraphs {
  &__paragraph {
    font-size: 25px;
    margin-bottom: 2vw;
  }
}
</style>
